import { DSButton } from "@components/design-system/molecules";
import React from "react";

export default function NewNoteButton({ onClick, disabled }) {
  return (
    <div id="createNewPatientSOAPButton">
      <DSButton
        variant="secondary"
        onClick={onClick}
        disabled={disabled}
        dataTestId="createNewPatientSOAPButton"
        style={{ width: "100%" }}
      >
        + New Typed Note
      </DSButton>
    </div>
  );
}
